import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import React from 'react'
import { usePresentacionContext } from '../context/presentacion.context';
import { NumericFormat } from 'react-number-format';
import { formatMoney, formatMoneyCustom } from '../../shared/utilitties/formatMoney';

const ComprobantesDialogDetalleTable = () => {
    
    const {comprobantes} =  usePresentacionContext();
    let totalComprobantes = 0.0
    let detalleDeComprobantesList = comprobantes.map((item:any) => {
      totalComprobantes += item.fac_total
      return {detalleRow: item.fat_descripcion_red + '-' + item.fac_tipo_comprobante + '-' + String(item.fac_sucursal).padStart(4, "0") + '-' + item.fac_numero.padStart(8,0),
      totalRow: item.fac_total}
       
      })

    const formatMoneyBodyTemplate = (monto: any) => {
      return (
        <React.Fragment>
          <NumericFormat
            value={monto}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={"$"}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </React.Fragment>
      );
    };
    
    const renderFooter = () => { return (<span  style={{ display: "flex",justifyContent:"end",marginRight:"12px" }}>Total ${formatMoneyCustom(totalComprobantes,2)}</span>)};
    return (
        
          <DataTable
            value={detalleDeComprobantesList}
            responsiveLayout="stack"
            style={{border: "2px solid #0085ca"}}
             size="small"
             footer={renderFooter}
           scrollable scrollHeight="180px"
          >
            <Column
            header="Comprobante"
              field="detalleRow"
            />
            <Column
              header="Total"
              field="totalRow"
              body={(rowData) => formatMoneyBodyTemplate(rowData.totalRow)}
              //body={(rowData) => formatMoney(rowData.totalRow)}
              style={{ justifyContent: "right" }}
            ></Column>
          </DataTable>
        
      );
}

export default ComprobantesDialogDetalleTable